import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { validarCodigoGoogleAuthenticator } from '../../../../actions/auth';
import { useForm } from '../../../../hooks/useForm';
import { ValidatorForm } from 'react-material-ui-form-validator';

const initialState = {
    codigo: ""
};


export const ModalToken = (props) => {

    const dispatch = useDispatch();
    const { datosQR, validado = false } = useSelector((state) => state.auth);

    const [errorValidacionCodigo, setErrorValidacionCodigo] = useState(false);


    const [formValues, handleInputChange] = useForm(initialState);

    const { codigo } = formValues;


    const inputChange = (e) => {
        handleInputChange(e);
        //VALIDO CONTENIDO
        if (e.target.name === "codigo") {
            if (e.target.value === "") {
                setErrorValidacionCodigo(true);
            } else {
                setErrorValidacionCodigo(false);
            }
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        let error = false;
        setErrorValidacionCodigo(false);
        if (codigo.length !== 6 || isNaN(codigo)) {
            error = true;
            setErrorValidacionCodigo(true);
        }
        if (!error) {
            const data = {
                code: codigo
            }
            dispatch(validarCodigoGoogleAuthenticator(data, true, props.cambiarEstadoSolicitudPostToken));
            props.close();
        }
    };

    return (
        <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
            <DialogTitle>{props.titulo}</DialogTitle>
            <DialogContent>
                {!validado && (
                    <Grid container justify='center'>
                        <Grid item xs={12} md={4}>
                            <Paper style={{ padding: 10, marginTop: 10 }}>
                                <ValidatorForm onSubmit={handleSubmit}>
                                    {datosQR?.mostrarQR && (
                                        <>
                                            <Typography variant="h6" align="center">
                                                Escanea el código QR usando la aplicación <strong>Google Authenticator</strong> en tu celular
                                            </Typography>
                                            <Typography variant="body2" align="center" color="textSecondary" style={{ marginTop: 8 }}>
                                                Si es la primera vez que configuras la autenticación en dos pasos, abre Google Authenticator, selecciona "Agregar cuenta" y elige "Escanear un código QR".
                                            </Typography>
                                            <Box display="flex" justifyContent="center" style={{ marginTop: 16 }}>
                                                <img
                                                    src={`data:image/png;base64,${datosQR.qrCode}`}
                                                    style={{ width: 300, height: 300 }}
                                                    alt="Código QR para Google Authenticator"
                                                />
                                            </Box>
                                        </>
                                    )}
                                    <Typography variant="h6" align="center">
                                        Ingresa el código de 6 dígitos de Google Authenticator
                                    </Typography>

                                    <TextField
                                        id="codigo"
                                        variant="outlined"
                                        margin="normal"
                                        error={errorValidacionCodigo}
                                        helperText={errorValidacionCodigo && "El codigo debe tener 6 caracteres"}
                                        required={true}
                                        fullWidth
                                        label="CODIGO"
                                        name="codigo"
                                        value={codigo}
                                        autoComplete="off"
                                        autoFocus
                                        inputProps={{ maxLength: 6 }}
                                        onChange={inputChange}
                                    />
                                    <Box my={2}>
                                        <Button
                                            color="primary"
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                        >
                                            Validar
                                        </Button>
                                    </Box>
                                </ValidatorForm>
                            </Paper>
                        </Grid>
                    </Grid>
                )}
            </DialogContent>
        </Dialog>
    )
}
